import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzK9Bl } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_BL: Record<
  PageIdWoofzK9Bl,
  TPageConfig
> = {
  [PageIdWoofzK9Bl.DOG_AGE_K9_BL]: {
    id: PageIdWoofzK9Bl.DOG_AGE_K9_BL,
    hasHeader: true,
  },
  [PageIdWoofzK9Bl.DOG_SEX_K9_BL]: {
    id: PageIdWoofzK9Bl.DOG_SEX_K9_BL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.DOG_BREED_K9_BL]: {
    id: PageIdWoofzK9Bl.DOG_BREED_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.DOG_BREED_ID_K9_BL]: {
    id: PageIdWoofzK9Bl.DOG_BREED_ID_K9_BL,
  },
  [PageIdWoofzK9Bl.URGE_K9_BL]: {
    id: PageIdWoofzK9Bl.URGE_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.CHALLENGES_K9_BL]: {
    id: PageIdWoofzK9Bl.CHALLENGES_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.URGE_1_K9_BL]: {
    id: PageIdWoofzK9Bl.URGE_1_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.LEASH_PULLING_K9_BL]: {
    id: PageIdWoofzK9Bl.LEASH_PULLING_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.URGE_LEASH_K9_BL]: {
    id: PageIdWoofzK9Bl.URGE_LEASH_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.DURING_WALK_K9_BL]: {
    id: PageIdWoofzK9Bl.DURING_WALK_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.URGE_NOT_ALONE_K9_BL]: {
    id: PageIdWoofzK9Bl.URGE_NOT_ALONE_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.AGRESSIVE_BEHAVIOR_K9_BL]: {
    id: PageIdWoofzK9Bl.AGRESSIVE_BEHAVIOR_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.TRIGGERS_K9_BL]: {
    id: PageIdWoofzK9Bl.TRIGGERS_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.URGE_2_K9_BL]: {
    id: PageIdWoofzK9Bl.URGE_2_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.BEHAVIOR_ISSUES_K9_BL]: {
    id: PageIdWoofzK9Bl.BEHAVIOR_ISSUES_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.DOG_ACT_K9_BL]: {
    id: PageIdWoofzK9Bl.DOG_ACT_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.DOG_OFF_AT_HOME_K9_BL]: {
    id: PageIdWoofzK9Bl.DOG_OFF_AT_HOME_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.REWARDS_K9_BL]: {
    id: PageIdWoofzK9Bl.REWARDS_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.IGNORE_COMMANDS_K9_BL]: {
    id: PageIdWoofzK9Bl.IGNORE_COMMANDS_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Bl.COMMANDS_61_K9_BL]: {
    id: PageIdWoofzK9Bl.COMMANDS_61_K9_BL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.COMMANDS_62_K9_BL]: {
    id: PageIdWoofzK9Bl.COMMANDS_62_K9_BL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.COMMANDS_63_K9_BL]: {
    id: PageIdWoofzK9Bl.COMMANDS_63_K9_BL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.URGE_3_K9_BL]: {
    id: PageIdWoofzK9Bl.URGE_3_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.PREPARE_SCREEN_K9_BL]: {
    id: PageIdWoofzK9Bl.PREPARE_SCREEN_K9_BL,
    hasHeader: true,
  },
  [PageIdWoofzK9Bl.DOG_PROFILE_K9_BL]: {
    id: PageIdWoofzK9Bl.DOG_PROFILE_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.URGE_REVIEWED_K9_BL]: {
    id: PageIdWoofzK9Bl.URGE_REVIEWED_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.SOCIAL_SCREEN_K9_BL]: {
    id: PageIdWoofzK9Bl.SOCIAL_SCREEN_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.PREPARE_FLOW_K9_BL]: {
    id: PageIdWoofzK9Bl.PREPARE_FLOW_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.EMAIL_K9_BL]: {
    id: PageIdWoofzK9Bl.EMAIL_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.NEWSLETTER_URGE_K9_BL]: {
    id: PageIdWoofzK9Bl.NEWSLETTER_URGE_K9_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Bl.DISCIPLINE_SCREEN_K9_BL]: {
    id: PageIdWoofzK9Bl.DISCIPLINE_SCREEN_K9_BL,
    hasHeader: true,
  },
  [PageIdWoofzK9Bl.SCRATCH_SCREEN_K9_BL]: {
    id: PageIdWoofzK9Bl.SCRATCH_SCREEN_K9_BL,
    hasHeader: true,
  },
  [PageIdWoofzK9Bl.SUBSCRIPTIONS_K9_BL]: {
    id: PageIdWoofzK9Bl.SUBSCRIPTIONS_K9_BL,
  },
  [PageIdWoofzK9Bl.CHAT_UPSELL_K9_BL]: {
    id: PageIdWoofzK9Bl.CHAT_UPSELL_K9_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Bl.UPSELL_K9_BL]: {
    id: PageIdWoofzK9Bl.UPSELL_K9_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Bl.UPSELL_FEEDING_GUIDE_K9_BL]: {
    id: PageIdWoofzK9Bl.UPSELL_FEEDING_GUIDE_K9_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Bl.UPSELL_EMOTIONAL_SUPPORT_K9_BL]: {
    id: PageIdWoofzK9Bl.UPSELL_EMOTIONAL_SUPPORT_K9_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Bl.DOWNLOAD_K9_BL]: {
    id: PageIdWoofzK9Bl.DOWNLOAD_K9_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Bl.ACCOUNT_K9_BL]: {
    id: PageIdWoofzK9Bl.ACCOUNT_K9_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
